module.exports = __webpack_public_path__ + "static/media/hp_12.ff25b6ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_12.jpg
// module id = 5823
// module chunks = 0